import _ from "lodash";
window._ = _;

import "@hotwired/turbo-rails";
import "controllers";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
